// Module
var code = "<div ng-if=\"visible\" ng-transclude></div> ";
// Exports
module.exports = code;